<template lang="pug">
b-modal#api-key-form(
  ref="modal"
  title="Generar API Key"
  ok-title="Generar"
  cancel-title="Cancelar"
  @ok="onSubmit"
  @show="resetForm"
)
  b-form(@submit.stop.prevent="onSubmit")
    b-form-group(
      invalid-feedback="Este campo es requerido"
      label="Nombre"
    )
      b-form-input(
        v-model="form.name"
        maxlength="256"
        :state="$v.$dirty ? !$v.form.name.$invalid : null"
      )
</template>

<script>
import { required } from 'vuelidate/lib/validators'
import { mapActions } from 'vuex'

export default {
  name: 'ApiKeyFrom',
  data () {
    return {
      loading: false,
      form: {
        name: ''
      }
    }
  },
  validations: {
    form: {
      name: { required }
    }
  },
  methods: {
    ...mapActions(['createApiKey']),
    resetForm () {
      this.form = {
        name: ''
      }
      this.$v.$reset()
    },
    async onSubmit (event) {
      event.preventDefault()
      if (this.$v.$invalid) {
        this.$v.$touch()
        return
      }
      this.loading = true
      try {
        await this.createApiKey(this.form)
        this.loading = false
        this.$bvToast.toast('API Key generada exitosamente', {
          title: 'Éxito',
          variant: 'success'
        })
        this.$refs.modal.hide()
        this.$emit('done')
      } catch (error) {
        this.loading = false
        this.$bvToast.toast('Error al generar API Key', {
          title: 'Error',
          variant: 'danger'
        })
      }
    }
  }
}
</script>

<style lang="scss">
#api-key-form {
  .form-control:focus {
    color: #495057;
    background-color: #fff;
    border-color: #869099;
    outline: 0;
    box-shadow: 0 0 0 0.2rem #ced4da;
  }
}
</style>
